import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import './DataSnackbar.scss';

const WarningIcon = ErrorIcon;

class DataSnackbar extends React.PureComponent {
  static propTypes = {
    dataResult: PropTypes.shape({
      message: PropTypes.string,
      secondaryMessage: PropTypes.string,
      warning: PropTypes.bool,
      success: PropTypes.bool,
      error: PropTypes.bool,
      info: PropTypes.bool,
    }),
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  }

  static defaultProps = {
    dataResult: undefined,
  };

  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.props.onClose();
  };

  render() {
    const { dataResult = undefined } = this.props;
    let message;
    let secondaryMessage;
    let Icon;
    let className = 'success';
    if (dataResult) {
      message = dataResult.message || '';
      secondaryMessage = dataResult.secondaryMessage || undefined;
      if (dataResult.error) {
        className = 'error';
        Icon = dataResult.icon || ErrorIcon;
      } else if (dataResult.warning) {
        className = 'warning';
        Icon = dataResult.icon || WarningIcon;
      } else if (dataResult.info) {
        className = 'info';
        Icon = dataResult.icon || InfoIcon;
      } else {
        Icon = dataResult.icon || SuccessIcon;
      }
    }
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        className={`grb-datasnackbar ${className}`}
        open={this.props.open}
        autoHideDuration={4000} // https://api.flutter.dev/flutter/material/SnackBar/duration.html
        onClose={this.handleClose}
        onExited={this.handleExited}
        ContentProps={{
          'aria-describedby': 'data-snackbar',
        }}
        message={(
          <div id="data-snackbar" className="grb-datasnackbar-message">
            {Icon && <Icon />}
            {secondaryMessage ? (
              <div className="grb-datasnackbar-message-texts">
                <Typography variant="body2" className="grb-datasnackbar-message-primary">{message}</Typography>
                <Typography variant="caption" className="grb-datasnackbar-message-secondary">{secondaryMessage}</Typography>
              </div>
            ) : (
              <Typography variant="body2" className="grb-datasnackbar-message-primary">{message}</Typography>
            )}
          </div>
        )}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            id="grb-close-snackbar-button"
            onClick={this.handleClose}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    );
  }
}

export default DataSnackbar;
